import { FC } from 'react'
import Layout from 'components/Layout/Layout'
import MaterialCostBulkUploadTemplate from 'components/Templates/MaterialCostBulkUploadTemplate'

const MaterialCostBulkUpload: FC = () => {
  return (
    <Layout title={'原価情報一括登録'} page="Material">
      <MaterialCostBulkUploadTemplate />
    </Layout>
  )
}

export default MaterialCostBulkUpload
